import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { CalAngularModule } from '@cvx/cal-angular';
import { AppRoutingModule } from './app-routing.module';
import { ShareModule } from './share/share.module';



@NgModule({ declarations: [
        AppComponent,
    ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CoreModule,
    ShareModule,
    CalAngularModule.forRoot('config.json')
  ],
  providers: [ provideHttpClient(withInterceptorsFromDi()) ]
})
export class AppModule { }
